__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-09-19-1789814181-stable-dev/";